import { lazy, Suspense, useEffect, useState } from 'react';
import type { BrandFilterViewModel } from 'autogen/swagger/all';
import useDrawer from 'components/generic/Drawer/hooks/useDrawer';
import Flex from 'components/Layout/components/Flex';
import Loader from 'components/Loader';
import FilterMenuDrawer from '../../FilterMenu/FilterMenuDrawer';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';

const LazyBrandFilterMenu = lazy(() => import('./BrandFilterMenu'));

// Fallback shell shown while lazy chunk loads; ensures correct header is displayed right away
const BrandFilterMenuFallback = ({ model }: { model: BrandFilterViewModel }) => {
    const id = model.attribute.id.toString();
    const { closeFilterMenu } = useFilterMenu(id);
    return (
        <FilterMenuDrawer
            id={id}
            headline={model.displayName}
            backButtonCallback={closeFilterMenu}
            withSearch={model.showSearch}
        >
            <Flex justifyContent={'center'}>
                <Loader variant={'default'} />
            </Flex>
        </FilterMenuDrawer>
    );
};

// Gate component
export default function BrandFilterMenuLazy({ model }: { model: BrandFilterViewModel }) {
    const id = model.attribute.id.toString();
    const { isOpen } = useDrawer(id);
    const [hasOpened, setHasOpened] = useState(false);

    // Set true when the menu is opened for the first time
    useEffect(() => {
        if (isOpen && !hasOpened) {
            setHasOpened(true);
        }
    }, [isOpen, hasOpened]);

    if (!hasOpened) return null;

    return (
        <Suspense fallback={<BrandFilterMenuFallback model={model} />}>
            <LazyBrandFilterMenu model={model} />
        </Suspense>
    );
}
